import { Component, OnInit, Input } from '@angular/core';
import { DialogComponent } from '../../modules/change-password/dialog/dialog.component';
import { MatDialog, MatIconRegistry,  MatCheckboxModule,  MatCheckboxChange } from '@angular/material';
import { ViewTextesLegauxComponent } from '../../modules/textes-legaux/view-textes-legaux/view-textes-legaux.component';
import { DisclaimerService } from '../../services/disclaimer.service';
import {TrackingService} from '../../services/tracking.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'oap-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  @Input() footerType: string;

  urlPolConf = 'assets/pdf/politique-de-confidentialite-patient.pdf';
  public cookiesPopinOpen: Boolean;
  public cookiesAccepted: Boolean;

  constructor(
    private dialog: MatDialog,
    private disclaimer: DisclaimerService,
    public tracking: TrackingService,
    private cookieService: CookieService
    ) {
      this.cookiesPopinOpen = false
      const cookiesValue = this.cookieService.get('oap-cookies-consent');
      if(cookiesValue === 'true') {
          this.cookiesAccepted = true
      } else {
          this.cookiesAccepted = false
      }
  	  
  }

  ngOnInit() {

  }

  refreshCookieConsent() {
      const cookiesValue = this.cookieService.get('oap-cookies-consent');
      if(cookiesValue === 'true') {
          this.cookiesAccepted = true
      } else {
          this.cookiesAccepted = false
      }
  }

  loadCgu() {
        //console.log('*** load CGU ***');
        const dialogRef = this.dialog.open(ViewTextesLegauxComponent,
            {
                panelClass: 'oap-dialog',
                disableClose: false,
                data: {
                    typeTexte: 'cgu'
                }
            }
        );
      this.tracking.pushDataLayer('Contenus','Vues','CGU');
  }

    loadMentionsLegales() {
        //console.log('*** load Mentions légales ***');
        const dialogRef = this.dialog.open(ViewTextesLegauxComponent,
            {
                disableClose: false,
                data: {
                    typeTexte: 'ml'
                }
            }
        );
        this.tracking.pushDataLayer('Contenus','Vues','Mentions legales');
    }

    openExternal(url: string) {
      this.disclaimer.openPopinExternal(url);
    }

    openCookiesPopin() {
      this.refreshCookieConsent()
      this.cookiesPopinOpen = true
    }

    closeCookiesPopin() {
       this.cookiesPopinOpen = false
    }

    OnChangeFooter($event) {
      this.cookiesAccepted = $event.checked;
    }

    submitCookies() {
        const acceptanceSting = this.cookiesAccepted ? 'true' : 'false'
        let expiredDate = new Date();
        expiredDate.setDate( expiredDate.getDate() + 183 );
        this.cookieService.set('oap-cookies-consent', acceptanceSting, expiredDate, null, null, null, null)
        this.cookiesPopinOpen = false
    }
}
